import React, { useEffect, useState } from "react";
import Header from '../components/ProductCondition/Header'
import SearchState from "../components/strengthAnalysis/SearchState";
import ColTable from '../components/strengthAnalysis/ColTable'
import ChartComponent from "../components/strengthAnalysis/ChartComponent";
import MONTHLY_QUALITY_ANALYSIS from "../data/strengthAnalysis/MonthlyQualityAnalysis";
import axios from "axios";
import config from "../config";
import { convertDateToyyyymmdd } from "../util/date";

const StrengthAnalysis = () => {
  const [reqData, setReqData] = useState({
    YDATE: new Date().getFullYear(),
    PKCDXX: 60,
    BSSWGH: 160,
  });
  const [resData, setResData] = useState()
  const [data, setData] = useState(MONTHLY_QUALITY_ANALYSIS);

  const handleSearchData = async () => {
    try {
    const resbody = await axios({
      url: `${config.apiUrl}/jospMCP.do`,
      method: 'POST',
      data: {
        ydate: reqData.YDATE,
        pkcdxx: reqData.PKCDXX,
        bsswgh: reqData.BSSWGH
      },
    })
    console.log(resbody)
    if (resbody.data.resultCount === 0)
      throw new Error('조회된 데이터가 없습니다.');;
    setResData(resbody.data.resultData);
    } catch(e) {
      alert(e.message)
      setResData([{}])
    }
  }

  useEffect(() => {
    handleSearchData();
  }, [])

  return (
    <div className="bg-blue-200 min-h-screen flex-col flex">
      <Header title={"월별 조습 품질 분석 조회"}/>
      <SearchState onclick={handleSearchData} requestData={reqData} setRequestData={setReqData}/>
      <ColTable data={resData && resData}/>
      <div className="w-[90%] max-h-[19rem] ml-3 py-4">
        {
          resData &&
          resData.map((data, index) => {
            return <ChartComponent data={data} key={index}/>
          })
        }        
      </div>
    </div>
  )
}



export default StrengthAnalysis;